import { Controller } from "@hotwired/stimulus"

// Collapses an ordered line's comment down to a bubble icon. The row is tight
// once a recipient picker sits in it, so the field only opens on demand — and
// when it does it takes the full width of the card rather than the narrow
// comments column. A saved comment reads back as a line beneath the row.
export default class extends Controller {
  static targets = ["field", "input", "text", "bubble"]

  declare fieldTarget: HTMLElement
  declare inputTarget: HTMLInputElement
  declare textTarget: HTMLElement
  declare hasTextTarget: boolean
  declare bubbleTarget: HTMLElement
  declare hasBubbleTarget: boolean

  edit() {
    this.fieldTarget.classList.remove("hidden")
    if (this.hasTextTarget) this.textTarget.classList.add("hidden")

    this.inputTarget.focus()
    // Caret at the end so editing an existing note continues it.
    const end = this.inputTarget.value.length
    this.inputTarget.setSelectionRange(end, end)
  }

  // Re-collapse on blur so the card returns to its compact height.
  close() {
    const comment = this.inputTarget.value.trim()

    this.fieldTarget.classList.add("hidden")

    if (this.hasTextTarget) {
      this.textTarget.textContent = comment
      this.textTarget.classList.toggle("hidden", comment === "")
    }

    // The row never re-renders after auto-save, so the bubble has to reflect
    // whether a comment exists on its own.
    if (this.hasBubbleTarget) {
      this.bubbleTarget.classList.toggle("text-primary", comment !== "")
    }
  }
}
